import React from "react";
import { observer } from "mobx-react";
import type { IResourcesStore } from "../../../resources/ResourcesStore";
import { injectFromApp } from "../../inject";
import { RichToolTipComponent } from "../../rich-tooltip/RichToolTipComponent";
import { NewsItem } from "../../../network/domain/NewsItem";

interface INewsItemComponentProps {
    newsItem: NewsItem;
    resourcesStore?: IResourcesStore;
}

@injectFromApp<INewsItemComponentProps>((stores) => ({
    resourcesStore: stores.resourcesStore,
}))

@observer
export class NewsItemComponent extends React.Component<INewsItemComponentProps> {
    render() {
        const { resourcesStore, newsItem } = this.props;
        const { resources } = resourcesStore!;

        const { header, maintenance, fromLocalDateTime, untilLocalDateTime } = newsItem;

        return (
            <RichToolTipComponent toolTipPosition={ "left" } toolTipResource={ "MoreInformation" } className={ "news-item" + (newsItem.maintenance ? " maintenance" : "") }>
                <a target={ "_blank" } href={ "/POW3/Resource/News" } rel="noreferrer">
                    { header } { maintenance && <><br/><span>{ resources.From } { fromLocalDateTime } - { resources.Until } { untilLocalDateTime }</span></> }
                </a>
            </RichToolTipComponent>
        );
    }
}
